(function () {
  if (window.__lgLuminary10ListingBadges) return;
  window.__lgLuminary10ListingBadges = true;

  var PRODUCT_CARD_SELECTOR = '.t4s-product, .product, .product-item, .grid__item, .card-wrapper, .product-card';
  var PRODUCT_LINK_SELECTOR = 'a[href*="/products/"]';
  var IMAGE_AREA_SELECTOR = '.t4s-product-img, .t4s-product-inner, .card__media, .product-image, .product-card__image-wrapper, .t4s-product-thumb';
  var PRICE_AREA_SELECTOR = '.t4s-product-price, .t4s-price, .price, .product-price, [class*="price"]';
  var discounts = Object.create(null);
  var fetchedPages = Object.create(null);
  var observer = null;

  function isCollectionPage() {
    return document.body && document.body.classList.contains('template-collection');
  }

  function productHandleFromUrl(value) {
    try {
      var pathname = new URL(value, window.location.href).pathname;
      var match = pathname.match(/\/products\/([^/?#]+)/i);
      return match && match[1] ? decodeURIComponent(match[1]) : '';
    } catch (error) {
      return '';
    }
  }

  function cardHandle(card) {
    var options = card.getAttribute('data-product-options');
    if (options) {
      try {
        var parsed = JSON.parse(options);
        if (parsed.handle) return parsed.handle;
      } catch (error) {}
    }

    var link = card.querySelector(PRODUCT_LINK_SELECTOR);
    return link ? productHandleFromUrl(link.getAttribute('href') || link.href) : '';
  }

  function readDiscountData(root) {
    var dataNode = root.querySelector('#lg-luminary10-products');
    if (!dataNode) return;

    var products = [];
    try {
      products = JSON.parse(dataNode.textContent || '[]');
    } catch (error) {
      products = [];
    }

    products.forEach(function (product) {
      if (product && product.handle) discounts[product.handle] = product;
    });
  }

  function findImageArea(card) {
    var candidates = card.querySelectorAll(IMAGE_AREA_SELECTOR);
    for (var index = 0; index < candidates.length; index += 1) {
      if (candidates[index].querySelector('img')) return candidates[index];
    }
    return null;
  }

  function applyDiscount(card) {
    var product = discounts[cardHandle(card)];
    if (!product) return;

    var imageArea = findImageArea(card);
    if (imageArea && !imageArea.querySelector('.lg-luminary10-badge')) {
      if (window.getComputedStyle(imageArea).position === 'static') imageArea.style.position = 'relative';
      var badge = document.createElement('span');
      badge.className = 'lg-luminary10-badge';
      badge.textContent = product.badge || '10% OFF';
      imageArea.appendChild(badge);
    }

    var priceArea = card.querySelector(PRICE_AREA_SELECTOR);
    if (priceArea && product.sale && product.original) {
      priceArea.classList.add('lg-luminary10-price');
      priceArea.innerHTML = '<span class="lg-luminary10-sale">' + product.sale + '</span><span class="lg-luminary10-original">' + product.original + '</span>';
    }
  }

  function applyAll(root) {
    if (!root) return;
    if (root.matches && root.matches(PRODUCT_CARD_SELECTOR)) applyDiscount(root);
    if (root.querySelectorAll) root.querySelectorAll(PRODUCT_CARD_SELECTOR).forEach(applyDiscount);
  }

  function nextPageUrl(root, baseUrl) {
    var next = root.querySelector('[data-load-more]:not([data-is-prev])');
    if (!next) return '';
    try {
      return new URL(next.getAttribute('href') || next.href, baseUrl || window.location.href).href;
    } catch (error) {
      return '';
    }
  }

  function crawlDiscountPages(url, pageCount) {
    if (!url || fetchedPages[url] || pageCount > 50) return Promise.resolve();
    fetchedPages[url] = true;

    return fetch(url, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to load collection discount data');
        return response.text();
      })
      .then(function (html) {
        var page = new DOMParser().parseFromString(html, 'text/html');
        readDiscountData(page);
        applyAll(document);
        var next = nextPageUrl(page, url);
        if (!next) return;
        return new Promise(function (resolve) {
          window.setTimeout(function () {
            resolve(crawlDiscountPages(next, pageCount + 1));
          }, 150);
        });
      })
      .catch(function () {
        delete fetchedPages[url];
      });
  }

  function start() {
    if (!isCollectionPage()) return;
    readDiscountData(document);
    applyAll(document);
    crawlDiscountPages(nextPageUrl(document), 1);

    if (!window.MutationObserver || observer) return;
    observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) applyAll(node);
        });
      });
    });
    observer.observe(document.querySelector('#MainContent') || document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  document.addEventListener('shopify:section:load', start);
})();
